import {createRoot} from '@wordpress/element';
import RadialWheel from './ServiceWheel/radial-wheel';

export const ServiceWheel = {
	init(blockEl: HTMLDivElement): void {
		this.mount(blockEl);
	},
	mount(blockEl: HTMLDivElement): void {
		if (blockEl.dataset.mounted === '1') {

			return;
		}

		const mountEl: HTMLDivElement = blockEl.querySelector('.service-wheel__mount') as HTMLDivElement;
		const dataEl: HTMLScriptElement = blockEl.querySelector('.service-wheel__data') as HTMLScriptElement;

		if (!mountEl || !dataEl) {
			return;
		}

		let payload: object;

		try {
			payload = JSON.parse(dataEl.textContent);
		} catch (error) {
			console.error('Radial wheel JSON konnte nicht geparst werden', error);
			return;
		}

		const root = createRoot(mountEl);
		// @ts-ignore
		root.render(<RadialWheel {...payload}/>);

		blockEl.dataset.mounted = '1';
	}
};
